import { getAddEmployeeAction, saveAddEmployeeActions } from "./action";

const initialState = {
  getAddEmployee: {},
  error: "",
  saveAddEmployee: null,
};

const getAddEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case getAddEmployeeAction.GET_ADD_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        getAddEmployee: action.payload,
      };
    case getAddEmployeeAction.GET_ADD_EMPLOYEE_DETAILS_ERROR:
      return {
        ...state,
        getAddEmployee: {},
        error: "",
      };

    case saveAddEmployeeActions.SAVE_ADD_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        saveAddEmployee: action.payload.data,
      };
    case saveAddEmployeeActions.SAVE_ADD_EMPLOYEE_DETAILS_ERROR:
      return {
        ...state,
        saveAddEmployee: [],
      };

    default:
      return state;
  }
};

export default getAddEmployeeReducer;
